<!-- 论文要求查看 -->
<template>
    <div class="el-Require">
        <el-row class="page_content">
            <h1 class="head_title">请假申请</h1>
            <div style="margin-bottom: 10px;">
                <el-button type="primary" @click="UploadPaper"
                    >请假申请</el-button
                >
            </div>
            <el-table :data="tableData" style="width: 100%" v-if="!flag">
                <el-table-column prop="id" label="编号" width="180">
                </el-table-column>
                <el-table-column prop="date" label="日期" width="180">
                </el-table-column>
                <el-table-column prop="name" label="是否离校" width="180">
                </el-table-column>
                <el-table-column prop="address" label="理由"> </el-table-column>
            </el-table>

            <el-form ref="form" :model="form" label-width="80px" v-if="flag">
                <el-form-item label="请假时间">
                    <el-date-picker
                        v-model="form.data"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy/MM/dd"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="是否离校">
                    <el-radio-group v-model="form.resource">
                        <el-radio value="是" label="是"></el-radio>
                        <el-radio value="否" label="否"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="请假理由">
                    <el-input type="textarea" v-model="form.desc"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit"
                        >立即提交</el-button
                    >
                </el-form-item>
            </el-form>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "leaveApply",
    data() {
        return {
            tableData: [
                {
                    id: Math.floor(Math.random() * 10152452645458),
                    date: "2025/06/11 - 2025/07/15",
                    name: "是",
                    address: "家里有事需要请假10天"
                }
            ],
            form: {
                data: undefined,
                resource: undefined,
                desc: undefined,
            },
            flag: false
        };
    },
    created() {},
    mounted() {},
    methods: {
        UploadPaper() {
            this.flag = true;
        },

        onSubmit() {
            this.$message({
                message: "提交成功！",
                type: "success"
            });
            console.log('this.form',this.form.data)
            this.tableData.push({
                id: Math.floor(Math.random() * 10152452645458),
                date: this.form.data[0] + ' - ' + this.form.data[1],
                name: this.form.resource,
                address: this.form.desc
            });
            this.form = {
                data: undefined,
                resource: undefined,
                desc: undefined
            };

            this.flag = false;
        }
    },
    beforeDestroy() {}
};
</script>
<style lang="less">
@import "../../styles/base.less";

.el-Require {
    .wd {
        color: @red;
    }

    // .el-dialog__body{
    //     border-top:1px solid #ebeef5;
    // }
}
</style>



// WEBPACK FOOTER //
// src/pages/leaveApply/leaveApply.vue